import { NgStyle } from '@angular/common';
import { Component, computed, input } from '@angular/core';

import type { Hero } from '../models/hero.model';

@Component({
  selector: 'wl-hero-wrapper',
  standalone: true,
  imports: [NgStyle],
  templateUrl: './hero-wrapper.component.html',
  styleUrls: [
    './hero-wrapper.component.ed.scss',
    './hero-wrapper.component.essent.scss',
  ],
})
export class HeroWrapperComponent {
  readonly hero = input<Hero>();
  readonly large = input<boolean>();

  readonly ariaLabel = computed(() => {
    const headingLine1 = this.hero()?.headingLine1.value;
    const headingLine2 = this.hero()?.headingLine2?.value;

    return [headingLine1, headingLine2].filter(Boolean).join(' ');
  });

  readonly backgroundImageStyle = computed(() => {
    const backgroundImageSrc = this.hero()?.backgroundImage?.value?.src;

    return backgroundImageSrc ? `url(${backgroundImageSrc})` : undefined;
  });
}
